import React from "react";
import { useTranslation } from "react-i18next";
import { Switch, FormControlLabel } from "@mui/material";
import { useMutation } from "react-query";
import { setOrganizationLeadFlowEnabled } from "../../api/api";
import { Organization } from "../../types/api.types";
import { showToastError, showToastSuccess } from "common/toast/toast";
import { queryClient } from "../../modules/queryClient";

interface LeadFlowEnabledSettingsProps {
  organization: Organization;
}

export const LeadFlowEnabledSettings: React.FC<
  LeadFlowEnabledSettingsProps
> = ({ organization }) => {
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation(setOrganizationLeadFlowEnabled, {
    onSuccess: (data) => {
      queryClient.setQueryData<Organization | undefined>("organization", data);
      queryClient.invalidateQueries("organization");
      showToastSuccess(t("organizationSettings.leadFlowEnabled.updateSuccess"));
    },
    onError: () => {
      showToastError(t("organizationSettings.leadFlowEnabled.updateError"));
    },
  });

  const handleChange = () => {
    if (isLoading) return;
    mutate(!organization.leadFlowEnabled);
  };

  return (
    <Switch
      checked={!!organization.leadFlowEnabled}
      onChange={handleChange}
      disabled={isLoading}
      color="primary"
    />
  );
};
